import styled from 'styled-components';

export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 0 0 20px;
  padding: 0 0 15px 50px;
  border-bottom: 1px solid #cdcdcd;
  transition: all ease-in-out 0.3s;

  .sidebar-active & {
    padding-left: 50px;

    @media screen and (min-width: 1200px) {
      padding-left: 0px;
    }
  }

  .heading {
    display: block;
    font-size: 22px;
    line-height: 25px;
    font-weight: 600;
    margin: 0;
  }

  .btn-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .btn-info {
    flex-shrink: 0;
    width: 24px;
    padding: 0;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  button {
    font-weight: 600;

    &.btn-more {
      min-width: 50px;
      padding: 12px 0px;
    }
  }
`;
